<template>
  <div class="workflow-manager-layout">
    <!-- Top-level tab switcher -->
    <v-tabs v-model="activeMainTab" color="primary" density="compact" bg-color="white"
      style="border-bottom: 1px solid #e0e0e0;">
      <v-tab value="workflows" prepend-icon="mdi-sitemap">Workflows</v-tab>
    </v-tabs>

    <v-window v-model="activeMainTab" style="flex:1; overflow:hidden; display:flex; flex-direction:column;">
      <!-- Workflows tab -->
      <v-window-item value="workflows" style="height:100%; display:flex; flex-direction:column;">

    <!-- View: List -->
    <div v-if="currentView === 'LIST'" class="view-container list-view">
      <div class="action-bar">
        <h3>Task Engine Workflows</h3>
        <v-btn color="primary" @click="createNewFlow" prepend-icon="mdi-plus" variant="outlined">
          Create New Flow
        </v-btn>
      </div>

      <div class="search-filter-bar">
        <v-text-field v-model="searchQuery" prepend-inner-icon="mdi-magnify" label="Search Workflows" single-line
          hide-details variant="outlined" density="compact" class="search-input"></v-text-field>

        <v-tabs v-model="activeTab" density="compact" color="primary">
          <v-tab :value="WORKFLOW_STATUS.ACTIVE">Active <v-chip v-if="getworkflowLength(WORKFLOW_STATUS.ACTIVE) > 0"
              size="x-small" color="primary" label>{{
                getworkflowLength(WORKFLOW_STATUS.ACTIVE) }}</v-chip></v-tab>
          <v-tab :value="WORKFLOW_STATUS.DRAFT">Draft <v-chip v-if="getworkflowLength(WORKFLOW_STATUS.DRAFT) > 0"
              size="x-small" color="primary" label>{{
                getworkflowLength(WORKFLOW_STATUS.DRAFT) }}</v-chip></v-tab>
        </v-tabs>
      </div>

      <div class="content-area">
        <div v-if="filteredWorkflows.length === 0" class="empty-state">
          <v-icon size="64" color="grey lighten-1">mdi-file-tree</v-icon>
          <p>No {{ activeTab }} workflows found.</p>
          <v-btn variant="text" color="primary" @click="createNewFlow">Create New Workflow</v-btn>
        </div>

        <div v-else class="workflow-grid">
          <v-card v-for="workflow in filteredWorkflows" :key="workflow.workflow_id" class="workflow-card">
            <div class="card-status-strip" :class="workflow.status"></div>
            <v-card-text>
              <div class="d-flex justify-space-between align-start mb-2">
                <div class="text-subtitle-1 font-weight-bold text-truncate">{{ workflow.title }}</div>
                <v-chip size="x-small" :color="getStatusColor(workflow.status)" label>{{ workflow.workflow_type
                }}</v-chip>
              </div>
              <p class="text-caption text-medium-emphasis mb-4 description-text">
                {{ workflow.description || 'No description provided.' }}
              </p>
              <div class="d-flex align-center text-caption text-grey">
                <v-icon size="small" class="me-1">mdi-clock-outline</v-icon>
                Updated: {{ simpleDateTimeFormat(workflow.updated_at) }}
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions v-if="activeTab === WORKFLOW_STATUS.ACTIVE">
              <v-spacer></v-spacer>
              <v-btn size="small" variant="text" color="primary" @click="handleView(workflow)"
                prepend-icon="mdi-sitemap">View</v-btn>
              <v-btn size="small" variant="text" color="info" @click="showJobs(workflow)"
                prepend-icon="mdi-clock-outline">Jobs</v-btn>
              <v-btn size="small" variant="text" color="warning" @click="markInactive(workflow)">Inactive</v-btn>
            </v-card-actions>
            <v-card-actions v-else>
              <v-spacer></v-spacer>
              <v-btn size="small" variant="text" color="primary" prepend-icon="mdi-sitemap"
                @click="editFlow(workflow)">Edit</v-btn>
              <v-btn size="small" variant="text" color="info" @click="showJobs(workflow)"
                prepend-icon="mdi-clock-outline">Jobs</v-btn>

              <v-btn size="small" variant="text" color="success" prepend-icon="mdi-check"
                @click="activateFlow(workflow)"><v-tooltip activator="parent" location="bottom">Activate
                  Workflow</v-tooltip></v-btn>
              <v-btn size="small" variant="text" color="error" prepend-icon="mdi-delete"
                @click="deleteFlow(workflow)"><v-tooltip activator="parent" location="bottom">Delete
                  Workflow</v-tooltip></v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>

    <!-- View: Create Form -->
    <div v-if="currentView === 'CREATE_FORM'" class="view-container form-view">
      <div class="form-container">
        <div class="form-header">
          <v-btn icon="mdi-arrow-left" variant="text" @click="cancelCreate" class="me-2"></v-btn>
          <h2>Create New Work Flow</h2>
        </div>
        <WorkFlowCreateForm @submit="handleFormSubmit" @cancel="cancelCreate" />
      </div>
    </div>

    <!-- View: Builder -->
    <div v-if="currentView === 'BUILDER'" class="view-container builder-view">
      <WorkFlowBuilder :config="currentConfig" :key="currentConfig ? currentConfig.workflow_id : 'new'"
        @back="backToList" @save="onWorkflowSaved" />
    </div>

    <!-- View: Jobs -->
    <div v-if="currentView === 'JOBS'">
      <v-toolbar title="Jobs" density="compact" color="primary" class="mb-2">
        <v-btn icon="mdi-close" variant="text" @click="backToList"></v-btn>
      </v-toolbar>
      <JobsView :jobs_list="jobs" @back="backToList" />
    </div>
    <ConfirmationAlert ref="confirmationAlertRef" />
    <ConfirmationText ref="confirmationTextRef" />

      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import WorkFlowCreateForm from './WorkFlowCreateForm.vue'
import WorkFlowBuilder from './WorkFlowBuilder.vue'
import WorkflowService from '@/services/workflowService.js';
import { WORKFLOW_STATUS } from '@/constants/constantsValues.js';
import dayjsMixin from "@/mixins/dayjsMixin";
import ConfirmationAlert from '../CustomComponents/ConfirmationAlert.vue';
import ConfirmationText from '../CustomComponents/ConfirmationText.vue';
import JobsView from '../AdminSettings/JobsView.vue';
export default {
  name: 'TaskEngineWorkFlow',
  mixins: [dayjsMixin],
  components: {
    WorkFlowCreateForm,
    WorkFlowBuilder,
    ConfirmationAlert,
    ConfirmationText,
    JobsView
  },
  data() {
    return {
      WORKFLOW_STATUS,
      activeMainTab: 'workflows',
      currentView: 'LIST', // 'LIST', 'CREATE_FORM', 'BUILDER'
      currentConfig: null,
      searchQuery: '',
      activeTab: WORKFLOW_STATUS.ACTIVE,
      workflows: [],
      jobs: []
    }
  },
  computed: {
    filteredWorkflows() {
      return this.workflows.filter(wf => {
        const matchesTab = wf.status === this.activeTab;
        const matchesSearch = wf.title.toLowerCase().includes(this.searchQuery.toLowerCase());
        return matchesTab && matchesSearch;
      });
    }
  },
  watch: {
    '$route.params': {
      handler(params) {
        this.handleRouteParams(params);
      },
      immediate: true
    }
  },
  methods: {
    createNewFlow() {
      this.$router.push({ name: 'Automations', params: { view: 'create' } });
    },
    cancelCreate() {
      this.$router.push({ name: 'Automations' });
    },
    handleFormSubmit(configData) {
      console.log('Form Submitted:', configData)
      this.currentConfig = configData
      this.$router.push({ name: 'Automations', params: { view: 'builder' } });
    },
    backToList() {
      this.$router.push({ name: 'Automations' });
    },
    onWorkflowSaved() {
      this.fetchWorkflows();
    },
    editFlow(workflow) {
      if (workflow && workflow.workflow_id) {
        this.currentConfig = workflow;
        this.$router.push({ name: 'Automations', params: { view: 'builder', id: workflow.workflow_id } });
      }
    },
    getStatusColor(status) {
      return status === WORKFLOW_STATUS.ACTIVE ? 'success' : 'grey';
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    },
    handleView(workflow) {
      this.editFlow(workflow);
    },
    async showJobs(workflow) {
      this.$router.push({ name: 'Automations', params: { view: 'jobs', id: workflow.workflow_id } });
    },
    async fetchJobs(id) {
      try {
        let res = await WorkflowService.getWorkflowJobs(id);
        this.jobs = res.data;
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async activateFlow(workflow) {
      const confirmed = await this.$refs.confirmationAlertRef.open({
        title: 'Confirm Activate',
        text: `Are you sure you want to activate ${workflow.title}?`
      });
      if (confirmed) {
        workflow.status = WORKFLOW_STATUS.ACTIVE;
        await WorkflowService.updateWorkflowStatus(workflow.workflow_id, { status: WORKFLOW_STATUS.ACTIVE });
        this.fetchWorkflows();
      }
    },
    async markInactive(workflow) {
      const confirmed = await this.$refs.confirmationAlertRef.open({
        title: 'Confirm Inactive',
        text: `Are you sure you want to deactivate ${workflow.title}?`
      });
      if (confirmed) {
        workflow.status = WORKFLOW_STATUS.DRAFT;
        await WorkflowService.updateWorkflowStatus(workflow.workflow_id, { status: WORKFLOW_STATUS.DRAFT });
        this.fetchWorkflows();
      }
    },
    async deleteFlow(workflow) {
      const confirmed = await this.$refs.confirmationTextRef.open({
        title: 'Confirm Delete',
        text: `Are you sure you want to delete ${workflow.title}? <br> To confirm delete, please type <b>"DELETE"</b> in the box below.`,
        confirmationText: "DELETE"
      });
      if (confirmed) {
        await WorkflowService.deleteWorkflow(workflow.workflow_id);
        this.fetchWorkflows();
      }
    },
    async fetchWorkflows() {
      let res = await WorkflowService.getWorkflows();
      this.workflows = res.data;
    },
    getworkflowLength(status) {
      return this.workflows.filter(wf => wf.status === status).length;
    },
    async handleRouteParams(params) {
      const view = params.view ? params.view.toLowerCase() : 'list';
      const id = params.id;

      if (view === 'create') {
        this.currentView = 'CREATE_FORM';
        this.currentConfig = null;
      } else if (view === 'builder') {
        if (id) {
          if (!this.currentConfig || this.currentConfig.workflow_id != id) {
            try {
              let res = await WorkflowService.getWorkflow(id);
              this.currentConfig = res.data;
              this.currentView = 'BUILDER';
            } catch (error) {
              console.error("Error fetching workflow:", error);
              this.$router.replace({ name: 'Automations' });
            }
          } else {
            this.currentView = 'BUILDER';
          }
        } else if (!this.currentConfig) {
          // If no ID and no config, user probably navigated to /builder directly.
          // Redirect to create to force proper setup.
          this.$router.replace({ name: 'Automations', params: { view: 'create' } });
        } else {
          this.currentView = 'BUILDER';
        }
      } else if (view === 'jobs') {
        if (id) {
          this.currentView = 'JOBS';
          this.fetchJobs(id);
        } else {
          this.$router.replace({ name: 'Automations' });
        }
      } else {
        this.currentView = 'LIST';
        this.currentConfig = null;
      }
    }
  },
  created() {
    this.fetchWorkflows();
  }
}
</script>

<style scoped>
.workflow-manager-layout {
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.view-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* List View Styles */
.action-bar {
  padding: 16px 24px;
  background: white;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action-bar h3 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.search-filter-bar {
  padding: 16px 24px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.search-input {
  max-width: 400px;
}

.content-area {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.workflow-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.workflow-card {
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.workflow-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-status-strip {
  height: 4px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.card-status-strip.active {
  background-color: #4caf50;
}

.card-status-strip.draft {
  background-color: #9e9e9e;
}

.description-text {
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.empty-state {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #888;
}

.empty-state p {
  margin: 16px 0;
  font-size: 16px;
}

/* Form View Styles */
.form-view {
  align-items: center;
  justify-content: center;
}

.form-container {
  width: 100%;
  max-width: 650px;
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.form-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
}

.form-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

/* Builder View Styles */
.builder-view {
  height: 100%;
}

.jobs-view {
  height: 100%;
}
</style>